import { api } from "./client";
import { syncIntervals, type SyncResult } from "./integrations";

export async function getSyncStatus(signal?: AbortSignal): Promise<import("@/types").SyncStatus> {
  const { data } = await api.get<import("@/types").SyncStatus>("/sync/status", { signal });
  return data;
}

export async function triggerIntervalsSync(signal?: AbortSignal): Promise<SyncResult> {
  return syncIntervals(30, signal);
}

export interface WellnessSyncResult {
  status: "success" | "skipped" | "error";
  new: number;
  updated: number;
  total: number;
}

export async function triggerWellnessSync(signal?: AbortSignal): Promise<WellnessSyncResult> {
  const { data } = await api.post<WellnessSyncResult>("/sync/wellness", undefined, { signal });
  return data;
}
